module.exports = __webpack_public_path__ + "assets/basic-arrow-down-dde7e3.svg";